import {
  Box,
  Card,
  Flex,
  Grid,
  Heading,
  IconButton,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../utils/Loader/Loader";
import Layout from "../Layout/Layout";
import useWebcallWidgetForm from "./useWebcallWidgetForm";
import WebcallRepresentation from "./WebcallRepresentation";
import WebcallWidgetForm from "./WebcallWidgetForm";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useContext } from "react";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";

export default function WebcallWidgetCustomizationPage() {
  const { widgetId } = useParams();
  const navigate = useNavigate();
  const agency = useContext(AgencyContext);
  const { textColor } = agency;

  const { form, isWidgetLoading, widget, getWidgetByIdWithParams } =
    useWebcallWidgetForm({
      widgetId,
    });
  const { watch } = form;
  const formColor = useColorModeValue("white", "gray.700");
  return (
      <VStack h="100%" spacing={2} borderRadius="md">
        <Flex direction={"column"} gap={3} w={"100%"} h={"100%"}>
          <Flex gap={2} w={"100%"} alignItems="center" py={2}>
            <IconButton
              icon={<IoMdArrowRoundBack />}
              variant="outline"
              size="sm"
              onClick={() => navigate(-1)}
            />
            <Heading color={textColor} fontSize="xl">
              {"Customize Widget"}
            </Heading>
          </Flex>

          <Card p={4} h={"100%"} w={"100%"} overflowY={"auto"}>
            {isWidgetLoading ? (
              <Loader />
            ) : widget ? (
              <Grid
                gap={2}
                gridTemplateColumns={"1fr 1fr"}
                h={"100%"}
                overflowY={"auto"}
              >
                <Box>
                  <Box bg={formColor} p={2}>
                    <WebcallWidgetForm
                      form={form}
                      getWidgetByIdWithParams={getWidgetByIdWithParams}
                    />
                  </Box>
                </Box>
                <Box border={"1px solid lightgray"} borderRadius={"md"} p={2}>
                  <WebcallRepresentation watch={watch} />
                </Box>
              </Grid>
            ) : (
              <Box>Widget not found</Box>
            )}
          </Card>
        </Flex>
      </VStack>
  );
}
